import supabase from "@/lib/supabase";

export async function debugSupabaseAuth() {
  console.log("=== Debugging Supabase Auth ===");
  
  // 1. Check stored token
  const storedToken = localStorage.getItem('sb-auth-token');
  console.log("1. Stored token exists:", !!storedToken);
  if (storedToken) {
    try {
      const parsed = JSON.parse(storedToken);
      console.log("   - Access token:", parsed.access_token?.substring(0, 50) + "...");
      console.log("   - User email:", parsed.user?.email);
      console.log("   - Expires at:", new Date(parsed.expires_at * 1000));
    } catch (e) {
      console.error("   - Failed to parse token:", e);
    }
  }
  
  // 2. Check Supabase getSession
  console.log("\n2. Testing supabase.auth.getSession():");
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  console.log("   - Session exists:", !!sessionData.session);
  console.log("   - Session error:", sessionError);
  if (sessionData.session) {
    console.log("   - Session token:", sessionData.session.access_token?.substring(0, 50) + "...");
  }
  
  // 3. Check Supabase getUser
  console.log("\n3. Testing supabase.auth.getUser():");
  const { data: userData, error: userError } = await supabase.auth.getUser();
  console.log("   - User exists:", !!userData.user);
  console.log("   - User error:", userError);
  if (userData.user) {
    console.log("   - User email:", userData.user.email);
    console.log("   - User ID:", userData.user.id);
  }
  
  // 4. Try to set session manually if needed
  if (storedToken && !sessionData.session) {
    console.log("\n4. Trying to set session manually:");
    try {
      const parsed = JSON.parse(storedToken);
      const { data, error } = await supabase.auth.setSession({
        access_token: parsed.access_token,
        refresh_token: parsed.refresh_token
      });
      console.log("   - Set session success:", !!data.session);
      console.log("   - Set session error:", error);
    } catch (e) {
      console.error("   - Failed to set session:", e);
    }
  }
  
  return {
    hasStoredToken: !!storedToken,
    hasSession: !!sessionData.session,
    hasUser: !!userData.user
  };
}

// Make it available globally
(window as any).debugSupabaseAuth = debugSupabaseAuth;